import { render, staticRenderFns } from "./bkwc.vue?vue&type=template&id=4d7fff38&scoped=true&"
import script from "./bkwc.vue?vue&type=script&lang=js&"
export * from "./bkwc.vue?vue&type=script&lang=js&"
import style0 from "./bkwc.vue?vue&type=style&index=0&id=4d7fff38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7fff38",
  null
  
)

export default component.exports